import { Heading } from '@apollo/orbit';
import React from 'react';

import { CardWithHeader } from 'src/app/graph/operationsPage/report-pane/section-report/performance-section/serviceReport/CardWithHeader';

import { ShimmerLoading } from '../common/loading/ShimmerLoading';
import { ErrorMessage } from '../errorMessage/ErrorMessage';

export type OverviewCardLoadingProps = {
  title: string;
  subtitle: string;
};

export const OverviewLoading = ({
  heading,
  loadingError,
  cards,
}: {
  heading?: React.ReactNode;
  loadingError?: boolean;
  cards: OverviewCardLoadingProps[];
}) => {
  return (
    <div>
      <Heading className="mb-4">{heading ?? 'Operations overview'}</Heading>
      {loadingError ? (
        <ErrorMessage />
      ) : (
        <div className="grid w-full grid-cols-1 gap-6 @5xl:grid-cols-3">
          {cards.map((card) => (
            <CardWithHeader
              title={card.title}
              subTitle={card.subtitle}
              key={`loading-shimmer-${card.title}`}
              className="h-[456px] rounded-md"
              cardContent={
                <>
                  <ShimmerLoading className="h-4 w-14" />
                  <ShimmerLoading className="h-4 w-28" />
                  <ShimmerLoading className="h-4 w-32" />
                  <ShimmerLoading className="h-4 w-56" />
                  <ShimmerLoading className="h-4 w-40" />
                  <ShimmerLoading className="h-4 w-52" />
                  <ShimmerLoading className="h-4 w-44" />
                  <ShimmerLoading className="h-4 w-52" />
                  <ShimmerLoading className="h-4 w-28" />
                </>
              }
            />
          ))}
        </div>
      )}
    </div>
  );
};
